import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import OpenInNewIcon from '@/assets/icons/ic-open-in-new.svg';
import PaperIcon from '@/assets/icons/ic-paper.svg';
import SlidesDownloadIcon from '@/assets/icons/ic-slides-download.svg';

import { DownloadButton } from '@/components/ui/shared/buttons/DownloadButton/DownloadButton';
import { ThinLecture } from '@/resources/ThinLecture';

import { MultipleResourceDownload } from './components/MultipleResourceDownload';

interface IResourceDownload {
  lecture: ThinLecture;
}

export const ResourceDownload: FC<IResourceDownload> = ({ lecture }) => {
  const { t } = useTranslation();

  const { paperLink, paperUrl, slideshowUrl } = lecture;

  if (slideshowUrl && (paperUrl || paperLink)) {
    return <MultipleResourceDownload pdfUrl={paperUrl} slidesUrl={slideshowUrl} paperLink={paperLink} />;
  }

  if (paperUrl) {
    return (
      <DownloadButton url={paperUrl} download="paper" rightIcon={<PaperIcon />}>
        {t('eventResource.downloadPaper')}
      </DownloadButton>
    );
  }

  if (paperLink) {
    return (
      <DownloadButton url={paperLink} rightIcon={<OpenInNewIcon />}>
        {t('eventResource.viewPaper')}
      </DownloadButton>
    );
  }

  if (slideshowUrl) {
    return (
      <DownloadButton url={slideshowUrl} download="slides" rightIcon={<SlidesDownloadIcon />}>
        {t('eventResource.downloadSlides')}
      </DownloadButton>
    );
  }

  return null;
};
